import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Layout from "../layout"
import { orderMeetingCancel, closeMeetingCancel } from "../../redux/modules/meeting";

const PopupRemove = ({data}) => {
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);

    const formatDate = () => {
        var d = data.timeslot.split(' ')[0].split('.'),
          month = d[1],
          day = d[0],
          year = d[2];
          
        if (month == 1) month = 'января'
        if (month == 2) month = 'февраля'
        if (month == 3) month = 'марта'
        if (month == 4) month = 'апреля'
        if (month == 5) month = 'мая'
        if (month == 6) month = 'июня'
        if (month == 7) month = 'июля'
        if (month == 8) month = 'августа'
        if (month == 9) month = 'сентября'
        if (month == 10) month = 'октября'
        if (month == 11) month = 'ноября'
        if (month == 12) month = 'декабря'
        
        return day + ' ' + month +  ' ' + year + ' в ' + data.timeslot.split(' ')[1]
    }

    const handleCancel = () => {
        dispatch(
            orderMeetingCancel({ 
                cmd: 'orders-cancel',
                id: data.id,
                comment: '',
                _debug_token: auth.token
            })
        )
    }

    const handleClose = () => {
        dispatch(closeMeetingCancel(closeMeetingCancel))
    }

    return (
        <Layout>
            <div className="popup-meeting">
                <Link to={-1} className="popup-meeting__close" onClick={handleClose}></Link>
                <div className="popup-meeting__wrap">
                    <div className="popup-meeting__title">Отмена {data.eventTypeId == 1 ? 'встречи' : 'брокер-тура'}</div>
                    <div className="popup-meeting__status popup-meeting__status_error">Вы уверены, что хотите отменить {data.eventTypeId == 1 ? 'встречу' : 'брокер-тур'}? </div>
                    <div className="popup-meeting__meet">
                        {formatDate()}
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="22" viewBox="0 0 8 22" fill="none">
                        <path d="M6.67627 1.34082L1.49989 20.6593" stroke="#2D2D2C" stroke-linecap="square"/>
                        </svg>
                        {data.formatId === '1' ? 'ОНЛАЙН' : 'ОФИС ПРОДАЖ'} <br/>
                        Менеджер: {data.manager}
                    </div>
                    <div className="popup-meeting__buttons">
                        <Link to={-1} className="btn" onClick={handleClose}>Нет, Оставить</Link>
                        <button className="btn btn_empty" onClick={handleCancel}>Да, отменить</button>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default PopupRemove